import { apiRequest, defaultErrorMessage } from './httpRequest';

/** PubChem has no compound for the name or CID (a 404), as opposed to PubChem being unreachable. */
export class PubChemNotFoundError extends Error {}

export type PubChemQuery = { readonly name: string } | { readonly cid: string };

// On-demand only, mirroring searchMolecules -- resolves a name/CID to a SMILES string that the
// caller feeds into the existing SMILES-import pipeline, per #135's decision record.
export async function lookupPubChemSmiles(query: PubChemQuery): Promise<string> {
  const params = 'name' in query ? { name: query.name } : { cid: query.cid };
  const path = `/external/pubchem?${new URLSearchParams(params)}`;
  const body = await apiRequest<{ smiles: string }>(path, 'PubChem lookup', undefined, {
    parseErrorMessage: async (response) => {
      const message = await defaultErrorMessage(response, 'PubChem lookup');
      if (response.status === 404) throw new PubChemNotFoundError(message);
      return message;
    }
  });
  return body.smiles;
}
